import React from "react";

export default function PublicProfileCard({
  title,
  subtitle,
  description,
  details = [],
  actions = null
}) {
  return (
    <article className="publicProfileCard">
      <h2>{title || "Profile"}</h2>

      {subtitle && (
        <p>{subtitle}</p>
      )}

      {description && (
        <p>{description}</p>
      )}

      {details.length > 0 && (
        <div className="publicProfileMeta">
          {details.map(detail => (
            <div key={detail.label}>
              <strong>{detail.label}</strong>
              <p>{detail.value || "Not set"}</p>
            </div>
          ))}
        </div>
      )}

      {actions && (
        <div className="publicProfileActions">
          {actions}
        </div>
      )}
    </article>
  );
}
